import React, { useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON_BACKGROUND, SKELETON_FOREGROUND } from '../../color';
import './SkeletonLoader.css';

const DEFAULT_RECT_ATTRIBUTES = [
  {
    type: 'rect',
    x: '0',
    y: '0',
    rx: '4',
    ry: '4',
    width: '100%',
    height: '100%',
  },
];

const GenericLoader = (props) => {
  const { rectAttributes, showError, setShowError, width, height } = props;

  useEffect(() => {
    if (setShowError) {
      const timeoutId = setTimeout(() => {
        setShowError(true);
      }, 30000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [setShowError]);

  if (showError) {
    return <div className="skeletonloader">Oops...Something went wrong.</div>;
  }

  const renderElements = () => {
    const attributes =
      Array.isArray(rectAttributes) && rectAttributes.length > 0
        ? rectAttributes
        : DEFAULT_RECT_ATTRIBUTES;

    return attributes.map((attribute, index) => {
      const { type, ...rest } = attribute;

      if (type === 'rect') {
        return <rect key={index} {...rest} />;
      } else if (type === 'circle') {
        return <circle key={index} {...rest} />;
      } else {
        return null;
      }
    });
  };

  return (
    <ContentLoader
      height={height ? height : 1000}
      width={width ? width : 1000}
      // viewBox={`0 0 ${width || 1000} ${height || 1000}`}
      backgroundColor={SKELETON_BACKGROUND}
      foregroundColor={SKELETON_FOREGROUND}
      // {...props}
    >
      {renderElements()}
    </ContentLoader>
  );
};

export default GenericLoader;
